import React from "react";
import { Tooltip } from "@mui/material";

interface TruncatedTextWithTooltipProps {
  text: string | null | undefined;
  maxLines?: number;
  minWidth?: string;
  maxWidth?: string;
  emptyPlaceholder?: string;
}

const TruncatedTextWithTooltip: React.FC<TruncatedTextWithTooltipProps> = ({
  text,
  maxLines = 4,
  minWidth = "200px",
  maxWidth = "400px",
  emptyPlaceholder = "-",
}) => {
  if (!text) return <span>{emptyPlaceholder}</span>;

  const lineHeight = 1.5;
  const maxHeight = `${maxLines * lineHeight}em`;

  return (
    <Tooltip
      arrow
      placement="top"
      title={
        <div
          style={{
            maxWidth: "450px",
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
          }}
        >
          {text}
        </div>
      }
      componentsProps={{
        tooltip: {
          sx: {
            maxWidth: 500,
            p: 1.5,
          },
        },
      }}
    >
      <div
        style={{
          minWidth,
          maxWidth,
          display: "-webkit-box",
          WebkitLineClamp: maxLines,
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
          textOverflow: "ellipsis",
          wordBreak: "break-word",
          lineHeight: lineHeight,
          maxHeight,
          cursor: "pointer",
        }}
      >
        {text}
      </div>
    </Tooltip>
  );
};

export default TruncatedTextWithTooltip;
